import React, {useState} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';

// Internal price breakdown. Rendered only when the pricing API returns a price_summary,
// which the server only includes for logged-in @diplomaframe.com accounts.
const PriceSummaryPanel: React.FC = observer(() => {
    const [open, setOpen] = useState(true);
    const ps = s.ui.price_summary;
    if (!ps) return null;

    const fmt = (n: number): string => (n < 0 ? `-${util.currency(Math.abs(n))}` : util.currency(n));

    return (
        <div
            className="gray-box"
            style={{marginTop: 12, fontSize: 13, textAlign: 'left'}}
        >
            <div
                style={{fontWeight: 700, cursor: 'pointer', display: 'flex', justifyContent: 'space-between'}}
                onClick={() => setOpen(!open)}
            >
                <span>
                    Price Breakdown (internal - visible if <a href="/Identity/Account/Manage">logged in</a> with an @diplomaframe.com account )
                </span>
                <span>{open ? '−' : '+'}</span>
            </div>
            {open && (
                <table style={{width: '100%', marginTop: 6, borderCollapse: 'collapse'}}>
                    <tbody>
                        {ps.lines.map((l, i) => (
                            <tr
                                key={i}
                                style={{borderTop: '1px solid #e3e3e3'}}
                            >
                                <td style={{padding: '3px 6px 3px 0'}}>
                                    {l.label}
                                    {l.note && <div style={{fontSize: 11, color: '#888'}}>{l.note}</div>}
                                </td>
                                <td style={{padding: '3px 0', textAlign: 'right', whiteSpace: 'nowrap', verticalAlign: 'top'}}>{fmt(l.amount)}</td>
                            </tr>
                        ))}
                        <tr style={{borderTop: '2px solid #bbb', fontWeight: 700}}>
                            <td style={{padding: '3px 6px 3px 0'}}>Total</td>
                            <td style={{padding: '3px 0', textAlign: 'right'}}>{fmt(ps.total)}</td>
                        </tr>
                        {ps.discounted_total !== ps.total && (
                            <tr style={{fontWeight: 700, color: '#b30000'}}>
                                <td style={{padding: '3px 6px 3px 0'}}>Discounted total (price slash)</td>
                                <td style={{padding: '3px 0', textAlign: 'right'}}>{fmt(ps.discounted_total)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
});

export default PriceSummaryPanel;
